import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIdeleteFileSize } from '../../../api/Files';

import { showModal } from '../../../actions';
import { showConfirmationModal } from '../../../actions/App';
import EmptyTableCell from '../../EmptyTableCell';

class AdminFileSizesListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.handleEdit = this.handleEdit.bind(this);
  }

  handleEdit(e) {
    const {
      size,
      openSizeEditModal,
      updateSizeOnList,
    } = this.props;

    e.preventDefault();
    openSizeEditModal({
      className: 'modal-edit-size',
      backdrop: true,
      size,
      afterCreateSize: updateSizeOnList,
    });
  }

  render() {
    const {
      intl,
      size,
      handleDeleteSize,
      deleteSizeFromList,
    } = this.props;

    return (
      <tr>
        <th scope="row" className="size-name">
          <a
            href="#edit"
            onClick={this.handleEdit}
          >
            {size.name}
          </a>
        </th>
        <td className="size-dimension">
          {size.width || '*'} x {size.height || '*'}
        </td>
        <td className="size-crop">
          {size.crop ? (
            <i className="far fa-check" />
          ) : <EmptyTableCell />}
        </td>
        <td className="action-more">
          <UncontrolledDropdown>
            <DropdownToggle nav className="options">
              <i className="far fa-ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem
                onClick={this.handleEdit}
              >
                <i className="fas fa-pencil" />
                {intl.formatMessage({ defaultMessage: 'Edit' })}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteSize(size, deleteSizeFromList);
                }}
              >
                <i className="fas fa-trash" />
                {intl.formatMessage({ defaultMessage: 'Delete' })}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  openSizeEditModal: (params) => {
    dispatch(showModal('FileSizeEditModal', params));
  },
  handleDeleteSize: (size, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this file size? The size will be permanently removed.' }),
      onConfirm: () => (
        APIdeleteFileSize(size.id).then(() => {
          callback(size);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminFileSizesListItem.propTypes = {
  intl: PropTypes.object.isRequired,
  openSizeEditModal: PropTypes.func.isRequired,
  handleDeleteSize: PropTypes.func.isRequired,
  updateSizeOnList: PropTypes.func.isRequired,
  deleteSizeFromList: PropTypes.func.isRequired,
  size: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminFileSizesListItem)));
